import { ApplicationApi, DemoUseDto, ModelDto, SelectItemDto } from 'api';
import { cacheTime, infinityCacheTime } from 'api/ReactQueryOptions';

const chachingTimeMin = 10;

export const travelUnitsQuery = (api: ApplicationApi) => ({
	queryKey: installationKeys.travelUnits(),
	queryFn: async () => (await api.getTravelReimbursementUnits()).data,
	...infinityCacheTime<string[]>(),
});

export const brandsQuery = (api: ApplicationApi, mainSegment: string) => ({
	queryKey: installationKeys.brands(mainSegment),
	queryFn: async () =>
		(await api.getBrandsByMainSegment({ mainSegment })).data,
	...infinityCacheTime<SelectItemDto[]>(),
});

export const modelsQuery = (api: ApplicationApi, brandId: number) => ({
	queryKey: installationKeys.models(brandId),
	queryFn: async () => (await api.getModelsByBrandId({ brandId })).data,
	...infinityCacheTime<ModelDto[]>(),
});

export const agreementsServiceTypesQuery = (api: ApplicationApi) => ({
	queryKey: installationKeys.agreementsServiceTypes(),
	queryFn: async () => (await api.getServiceTypes()).data,
	...infinityCacheTime<SelectItemDto[]>(),
});

export const agreementsBusinessModelsQuery = (api: ApplicationApi) => ({
	queryKey: installationKeys.agreementsBusinessModels(),
	queryFn: async () => (await api.getBusinessModels()).data,
	...infinityCacheTime<SelectItemDto[]>(),
});

export const demoUseQuery = (api: ApplicationApi, id: number) => ({
	queryKey: installationKeys.demoUse(id),
	queryFn: async () => (await api.getDemoUse({ id })).data,
});

export const demoUsesQuery = (api: ApplicationApi, unitId: number) => ({
	queryKey: installationKeys.demoUses(unitId),
	queryFn: async () =>
		(await api.getDemoUses({ unitId: unitId.toString() })).data,
	...cacheTime<DemoUseDto[]>(chachingTimeMin),
});

export const installationKeys = {
	all: ['installation'] as const,
	brands: (mainSegment: string) =>
		[...installationKeys.all, 'brands', mainSegment] as const,
	models: (brand: number) =>
		[...installationKeys.all, 'models', brand] as const,
	travelUnits: () => [...installationKeys.all, 'travel-units'] as const,
	agreementsServiceTypes: () =>
		[...installationKeys.all, 'agreements-service-types'] as const,
	agreementsBusinessModels: () =>
		[...installationKeys.all, 'agreements-business-models'] as const,
	demoUse: (id: number) => [...installationKeys.all, 'demoUse', id] as const,
	demoUses: (unitId: number) =>
		[...installationKeys.all, 'demoUses', unitId] as const,
};
